"use client"

import { useSisterSiteNavigation } from "@/utils/navbar/useSisterSiteNavigation"
import { SisterSiteKey } from "@/types/auth"

const SISTER_SITE_MAP: Record<string, SisterSiteKey> = {
   Academy: "training",
   Jobs: "jobs",
   Events: "events",
}

export function FooterSisterSiteLink({
   title,
   href,
   className,
}: {
   title: string
   href: string
   className?: string
}) {
   const { buildHandler } = useSisterSiteNavigation()
   const key = SISTER_SITE_MAP[title]
   return (
      <a
         href={href}
         className={className}
         onClick={buildHandler(href, key)}
         aria-label={`Navigate to ${title} page`}
      >
         {title}
      </a>
   )
}
